import React from 'react';

const LanguageContext = React.createContext({
    language: 'de',
    availableLanguages: [],
    setLanguage: () => {},
});

export default LanguageContext;